import ContactTeamButton from '@/app/components/common/ContactTeamButton';
import { FAQ } from '@/app/components/faq/FAQ';
import animationData from '@/assets/animations/risk-graph.json';
import MarkdownText from '@/components/markdown/markdown-text';
import { Box, Flex, Text } from '@cmpsr/components';
import Lottie from 'lottie-react';
import { text } from '../../../common/theme';
import ComparisonTable from '../comparison-table/ComparisonTable';
import { ContentContainerV2 } from '../ContentContainer';
import HowItWorks from '../how-it-works/HowItWorks';
import { ImageCarousel } from './ImageCarousel';
import IndustryProofs from './IndustryProofs';
import { VARS } from '../../../common/constants';

const AdditionalInformation = () => {
  return (
    <Box
      backgroundColor="tan"
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      pt="spacer-8"
      paddingBottom="100px"
      gap="spacer-8"
    >
      <ContentContainerV2>
        <Text textAlign="center" w={{ base: '295px', lg: '500px' }} {...text.body.semiBold}>
          Based on Research from Leading Institutions & Data from 10,000+ Clinical Studies
        </Text>
      </ContentContainerV2>
      <IndustryProofs />
      <ContentContainerV2 gap="spacer-8" py="spacer-12">
        <ContentContainerV2 flexDirection="column" gap="spacer-2" alignItems="center" textAlign="center">
          <HowItWorks />
        </ContentContainerV2>
      </ContentContainerV2>

      <MarkdownText textAlign="center" {...text.mobile.h3} w={{ base: '345px', lg: '630px' }}>
        **Reduce your cancer risk** by up to 60% with a **Catch Membership**
      </MarkdownText>
      <Box
        width={{ base: '350px', lg: '630px' }}
        height={{ base: '200px', lg: '370px' }}
        ml={{ base: '-12px', lg: '-25px' }}
      >
        <Lottie animationData={animationData} />
      </Box>
      <ContentContainerV2 pt="spacer-12">
        <MarkdownText textAlign="center" {...text.mobile.h2.primary}>
          Join thousands of members **reducing their cancer risk**
        </MarkdownText>
      </ContentContainerV2>
      <ImageCarousel />
      <ContentContainerV2 gap="12" pt="spacer-12">
        <MarkdownText textAlign="center" {...text.mobile.h2.primary}>
          {`~~**$5,000**~~ of value for just **${VARS.price.yearly}** a year`}
        </MarkdownText>

        <ComparisonTable backgroundColor="tan" defaultTextColor="white" />

        <Flex justifyContent="center" alignItems="center" flexDirection="column">
          <Text
            color="darkBlue"
            fontSize="32px"
            fontFamily="Inter"
            fontStyle="normal"
            fontWeight="400"
            lineHeight="48px"
            textAlign="center"
          >
            Frequently Asked Questions
          </Text>
          <FAQ variant="dark" />
          <Text
            color="darkBlue"
            fontSize="30px"
            fontFamily="Inter"
            fontStyle="normal"
            fontWeight="400"
            lineHeight="48px"
            textAlign="center"
          >
            Have Questions?
          </Text>
        </Flex>
        <ContactTeamButton variant="light" />
      </ContentContainerV2>

      <Box height={{ base: '8px', lg: '0px' }} />
    </Box>
  );
};

export default AdditionalInformation;
